import React, { useState } from 'react';
import ContextOptions from 'components/ContextOptions';
import styled from 'styled-components';
import isEmptyObject from 'utils/isEmptyObject';

const IconContainer = styled.div`
  cursor: pointer;
  color: #999;
`;

const ContextOptionsFormatter = (props) => {
  const [renderOptions, setShouldRenderOptions] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  if (!props.column.editable) return null;

  const openContext = (event) => {
    const pos = event.target.getBoundingClientRect();
    const y = pos.bottom;
    const x = pos.x - 20;
    setShouldRenderOptions(true);
    setPosition({ x: x, y: y });
  };

  const close = () => setShouldRenderOptions(false);

  const { dependentValues, rowIdx, value } = props;

  const rowData = dependentValues.rowData;

  if (isEmptyObject(rowData)) return null;

  let options = dependentValues.options;
  if (typeof options === 'function') {
    options = options(rowData);
  }

  if (options.length === 0) return null;

  if (Array.isArray(options) && options.length === 1) {
    const option = options[0];
    let content = option.label;
    if (option.icon) {
      content = <i className="iconSmall">{option.icon}</i>;
    }

    return (
      <IconContainer onClick={option.onClick.bind(null, value, close, rowIdx, dependentValues)}>
        {content}
      </IconContainer>
    );
  }
  return (
    <div onClick={openContext}>
      <ContextOptions
        shouldRender={renderOptions}
        options={options}
        value={value}
        rowIdx={rowIdx}
        close={close}
        y={position.y}
        x={position.x}
      />
    </div>
  );
};

export default ContextOptionsFormatter;
